import { Typography, Chip } from '@material-tailwind/react';
import { CheckboxUI } from '../../../Interface';
import { ColorPicker } from '../../../../config/ColorPicker';
import { Box, IconButton } from '@mui/material';
import appService from '../../../../service/app.service';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import DescriptionIcon from '@mui/icons-material/Description';
import dayjs from 'dayjs';
import useParam from '../../../../context/ParamContext';

import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

dayjs.extend(isSameOrBefore);

export default function TaskListTodoCard({
  setTaskListTodo,
  task,
  autoCompleteOptions,
  user,
  type,
  setReportDialogData,
  setTaskDialogData,
}) {
  const { params } = useParam();
  const colorCardBackground = ColorPicker.find((colbg) => colbg.colorName === task.status?.color);

  const handleUpdateReadAt = () => {
    const findedItem = task.messages?.find((msg) => msg.lineId === task.id);
    appService.updateReadAt(findedItem.id).then(() => {
      setTaskListTodo((prevTasks) =>
        prevTasks.map((t) => {
          if (t.id !== task.id) return t;
          return {
            ...t,
            messages: t.messages?.filter((msg) => msg.id !== findedItem.id),
          };
        })
      );
    });
  };

  const finishedStatusId = Number(params.TASKLIST_TODO_FINISHED_STATUS);
  const isFinished = Number(task.statusId) === finishedStatusId;

  const now = dayjs();
  const hasDeadline = !!task.deadLine;

  const isOverdue = hasDeadline && !isFinished && dayjs(task.deadLine).isBefore(now);
  const isDueSoon = hasDeadline && !isFinished && !isOverdue && dayjs(task.deadLine).isSameOrBefore(now.add(4, 'day'));

  return (
    <Box
      sx={{
        width: '450px',
        borderRadius: '12px',
        display: 'flex',
        justifyContent: 'space-between',
        background: colorCardBackground?.colorBgCode,
        border: `4px solid ${task?.responsiblePerson?.color || 'transparent'}`,
      }}
    >
      <Box px={2} py={1} width="100%">
        <Box mb={0.5}>
          <Typography variant="small" color="blue-gray" className="opacity-70">
            Projekt
          </Typography>
          <Typography variant="h6" color="blue-gray">
            {autoCompleteOptions.project.find((project) => project.value === task.lineId)?.label}
          </Typography>
        </Box>

        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box mb={0.5}>
            <Typography variant="small" color="blue-gray" className="opacity-70">
              Feladat
            </Typography>
            <Typography variant="h6" color="blue-gray" className="flex items-center gap-3">
              {task.name}
              {/*<Chip
                variant="ghost"
                value={`${task.preparedness ?? 0} %`}
                className="rounded-full"
                style={{
                  background: task.preparedness < 100 ? 'rgba(254, 215, 170, 0.6)' : 'rgba(187, 247, 208, 1)',
                  color: task.preparedness < 100 ? 'rgba(249, 115, 22, 1)' : 'rgba(22, 163, 74, 1)',
                }}
                size="sm"
              />*/}
            </Typography>
          </Box>
          <Box pt={1}>
            {task?.messages?.length > 0 && <CheckboxUI onChange={() => handleUpdateReadAt()} label="Elolvastam" />}
            <Typography variant="h6">{task?.userGroup?.name}</Typography>
          </Box>
        </Box>
        <Box display="flex" justifyContent="space-between" flexWrap="wrap">
          <Box>
            <Typography variant="small" color="blue-gray" className="opacity-70">
              Kezdő dátum
            </Typography>
            <Typography variant="h6" color="blue-gray">
              {dayjs(task.startDate).format('YYYY-MM-DD')}
            </Typography>
          </Box>
          <Box>
            <Typography variant="small" color="blue-gray" className="opacity-70">
              Határidő
            </Typography>
            <Typography
              variant="h6"
              style={{
                color: isOverdue ? 'rgb(239, 68, 68)' : isDueSoon ? 'rgb(249, 115, 22)' : '#263238',
              }}
            >
              {task.deadLine ? dayjs(task.deadLine).format('YYYY-MM-DD HH:mm') : 'N/A'}
            </Typography>
          </Box>
          <Box>
            <Typography variant="small" color="blue-gray" className="opacity-70">
              Felelős
            </Typography>
            <Typography variant="h6" color="blue-gray">
              {task.responsiblePerson?.nickName ?? 'N/A'}
            </Typography>
          </Box>
        </Box>
        {task.taskListRespPerson?.length ? (
          <Box mt={0.5}>
            <Typography variant="small" color="blue-gray" className="opacity-70">
              További felelősök
            </Typography>
            <Typography variant="h6" color="blue-gray">
              {task.taskListRespPerson?.map((rp) => rp.respUser?.nickName).join(', ')}
            </Typography>
          </Box>
        ) : (
          ''
        )}
      </Box>
      <Box textAlign="center">
        <IconButton sx={{ m: 0, p: 0, mb: 1 }} onClick={() => setTaskDialogData({ open: true, id: task.id })}>
          <RemoveRedEyeIcon sx={{ fontSize: '2rem' }} />
        </IconButton>
        <IconButton
          sx={{ m: 0, p: 0, mb: 1 }}
          disabled={['all', 'opened'].includes(type)}
          onClick={() =>
            setReportDialogData({
              open: true,
              data: {
                projectId: task.lineId,
                taskListId: task.id,
                statusId: task.statusId,
                responsiblePersonId: task.responsiblePersonId,
              },
            })
          }
        >
          <DescriptionIcon sx={{ fontSize: '2rem' }} />
        </IconButton>
      </Box>
    </Box>
  );
}
